function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useState } from "react";
import PropTypes from "prop-types";
import { nanoid } from "nanoid";
import useTheme from "../../hooks/useTheme";
import useBackground from "../../hooks/useBackground";
import useResponsivePropsCSS from "../../hooks/useResponsivePropsCSS";
import VisuallyHidden from "../VisuallyHidden";
import { jsx as ___EmotionJSX } from "@emotion/core";
var COLORS = ["grey.t05", "white"];
var DEFAULT_PROPS = {
  color: "grey.t05",
  disabled: false,
  __internal__keyboardFocus: false
};
InternalCheckbox.COLORS = COLORS;
InternalCheckbox.DEFAULT_PROPS = DEFAULT_PROPS;

function CheckboxIcon(_ref) {
  var _color = _ref.color,
      isChecked = _ref.isChecked;
  var theme = useTheme();

  var _useBackground = useBackground(),
      inputColorMap = _useBackground.inputColorMap;

  var rectCSS = useResponsivePropsCSS({}, {}, {
    color: function color(propsAtBreakpoint, theme, bp) {
      return theme.checkbox.getCSS({
        targetElement: "svgRect",
        color: _color !== null && _color !== void 0 ? _color : inputColorMap[bp],
        isChecked: isChecked
      });
    }
  });
  return ___EmotionJSX("svg", {
    css: theme.checkbox.getCSS({
      targetElement: "svg"
    }),
    viewBox: "0 0 100 100",
    focusable: "false",
    "aria-hidden": "true"
  }, ___EmotionJSX("rect", {
    css: rectCSS,
    width: "100",
    height: "100",
    rx: "16"
  }), isChecked && ___EmotionJSX("path", {
    css: theme.checkbox.getCSS({
      targetElement: "svgPath"
    }),
    d: "M21 51 l22 18 l35 -39",
    fill: "transparent",
    strokeWidth: "14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

CheckboxIcon.propTypes = {
  color: PropTypes.oneOf(COLORS),
  isChecked: PropTypes.bool.isRequired
};

function InternalCheckbox(_props) {
  var props = _objectSpread(_objectSpread({}, DEFAULT_PROPS), _props);

  var name = props.name,
      parentName = props.parentName,
      color = props.color,
      disabled = props.disabled,
      isValid = props.isValid,
      labelledBy = props.labelledBy,
      describedBy = props.describedBy,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      value = props.value,
      onChange = props.onChange,
      onMouseDown = props.onMouseDown,
      children = props.children,
      __internal__keyboardFocus = props.__internal__keyboardFocus;
  var theme = useTheme();

  var _useBackground2 = useBackground(),
      inputColorMap = _useBackground2.inputColorMap;

  var _useState = useState(function () {
    var _props$inputId;

    return (_props$inputId = props.inputId) !== null && _props$inputId !== void 0 ? _props$inputId : "checkbox-".concat(nanoid());
  }),
      _useState2 = _slicedToArray(_useState, 1),
      inputId = _useState2[0];

  var labelCSS = useResponsivePropsCSS(props, DEFAULT_PROPS, {
    color: function color(propsAtBreakpoint, theme, bp) {
      var _props$color;

      return theme.checkbox.getCSS({
        targetElement: "label",
        color: (_props$color = _props.color) !== null && _props$color !== void 0 ? _props$color : inputColorMap[bp],
        __internal__keyboardFocus: __internal__keyboardFocus
      });
    }
  });
  return ___EmotionJSX("div", {
    css: theme.checkbox.getCSS({
      targetElement: "container"
    }),
    "aria-invalid": isValid ? null : "true",
    "aria-labelledby": labelledBy,
    "aria-describedby": describedBy
  }, ___EmotionJSX(VisuallyHidden, null, ___EmotionJSX("input", {
    css: theme.checkbox.getCSS({
      targetElement: "input"
    }),
    type: "checkbox",
    id: inputId,
    name: name,
    "data-parent-name": parentName,
    checked: value,
    disabled: disabled,
    onFocus: onFocus,
    onBlur: onBlur,
    onChange: onChange
  })), ___EmotionJSX("label", {
    css: labelCSS,
    htmlFor: inputId,
    onMouseDown: onMouseDown
  }, ___EmotionJSX(CheckboxIcon, {
    color: color,
    isChecked: value
  }), ___EmotionJSX("span", null, children)));
}

InternalCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  parentName: PropTypes.string,
  inputId: PropTypes.string,
  color: PropTypes.oneOf(COLORS),
  disabled: PropTypes.bool,
  isValid: PropTypes.bool.isRequired,
  labelledBy: PropTypes.string,
  describedBy: PropTypes.string,
  onFocus: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onMouseDown: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  __internal__keyboardFocus: PropTypes.bool
};
export default InternalCheckbox;